<template lang="html">
  <div class="full-page">
    <i-header title="风险测评" @leftClick="$router.go(-1)">
      <span slot="left"><i class="cubeic-back"></i></span>
    </i-header>
    <i-body>
      <div class="risk-question">
        <i-empty :show="questions.length === 0" @click="$_getRiskQuestions"></i-empty>
        <div
          v-for="(item, index) in questions"
          :key="index"
          v-show="current === index"
          class="risk-question-by">
          <!-- 操作按钮 -->
          <div class="risk-question-actions">
            <div
              @click="$_handlePrev(index)"
              class="risk-question-actions-a"
              :class="{ 'actions-disabled': current === 0 }">
              上一题
            </div>
            <div class="risk-question-actions-current">{{`${current + 1}/${questions.length}`}}</div>
            <div
              @click="$_handleNext(index)"
              class="risk-question-actions-a"
              :class="{ 'actions-disabled': current === questions.length - 1 }">
              下一题
            </div>
          </div>
          <!-- 进度条 -->
          <div class="risk-question-process">
            <i-process :width="Number((current + 1)/(questions.length)*100)" />
          </div>
          <!-- 题目选项 -->
          <div class="risk-question-questions">
            <div class="risk-question-questions-title">{{item.questionContent}}</div>
            <div class="risk-question-questions-items">
              <div
                v-for="(items, indexs) in item.answerList"
                :key="indexs"
                @click="$_handleSelect(item.questionKey, items, index)"
                :class="{'items-active': selectJson[index].answerId === items.answerId}"
                class="risk-question-questions-item">
                {{items.answerContent}}
              </div>
            </div>
          </div>
        </div>

        <div v-if="current === (questions.length -1) && current !== 0 " class="risk-question-ft">
          <!-- 温馨提示 -->
          <div class="risk-question-tips">
            <div class="risk-question-tips-title">温馨提示</div>
            <div class="risk-question-tips-content">
              本人已经了解并愿意遵守国家有关证券市场、基金市场管理的法律、法规、规章及相关业务规则，
              本人在此郑重承诺以上填写的内容真实、准确、完整。若本人提供的信息发生任何重大变化，本人将及时书面通知贵公司。
            </div>
          </div>
          <div class="foot-btn">
            <cube-button :disabled="!selectJson[current].answerId" @click="$_handleSubmit">提交</cube-button>
          </div>
        </div>
      </div>
    </i-body>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';
import { getRiskQuestionsNew, getRiskQuestionsCal } from '../../api/risk';

export default {
  data() {
    return {
      questions: [],
      current: 0,
      selectJson: {},
    };
  },
  computed: {
    ...mapGetters(['managerInfo', 'au']),
  },
  created() {
    this.toast = this.$createToast({
      txt: '加载中...',
      type: 'loading',
      mask: true,
      time: 0,
    });
  },
  mounted() {
    this.$_getRiskQuestions();
  },
  methods: {
    $_getRiskQuestions() {
      const toast = this.$createToast({
        txt: '加载中...',
        type: 'loading',
        mask: true,
        time: 0,
      }).show();
      setTimeout(() => {
        getRiskQuestionsNew({
          sysCode: this.managerInfo.sysCode,
          managerAdminUserId: this.managerInfo.managerAdminUserId,
        }, this.au).then((res) => {
          toast.hide();
          if (res.code === 0) {
            this.questions = res.data.list[0].questionInfos;
            this.questions.forEach((val, index) => {
              this.selectJson[index] = {};
            });
          } else {
            this.$createToast({
              type: 'txt',
              txt: res.msg,
              mask: true,
              time: 2000,
            }).show();
          }
        });
      }, 100 * 10);
    },
    $_handlePrev(index) {
      if (index === 0) return;
      this.current = index - 1;
    },
    $_handleNext(index) {
      if (this.current === this.questions.length - 1) return;
      if (this.selectJson[index].answerId) {
        this.current = index + 1;
      } else {
        this.$createToast({
          type: 'txt',
          txt: '请选择',
          time: 1000,
        }).show();
      }
    },
    $_handleSelect(questionKey, items, index) {
      this.$set(this.selectJson, index, { questionKey, answerId: items.answerId });
      this.$forceUpdate();
      setTimeout(() => {
        this.$_handleNext(index);
      }, 300);
    },
    $_handleSubmit() {
      const answerJson = [];
      Object.keys(this.selectJson).forEach((key) => {
        answerJson.push(this.selectJson[key]);
      });
      // loading
      const toast = this.$createToast({
        txt: '加载中...',
        type: 'loading',
        mask: true,
        time: 0,
      }).show();

      getRiskQuestionsCal({
        sysCode: this.managerInfo.sysCode,
        managerAdminUserId: this.managerInfo.managerAdminUserId,
        userId: this.managerInfo.invenstemUserId,
        answerJsonStr: JSON.stringify(answerJson),
      }, this.au).then((res) => {
        toast.hide();
        if (res.code === 0) {
          const riskResult = res.data.bean;
          this.$store.dispatch('changeRiskResult', riskResult).then(() => {
            if (riskResult.evaluationResult === 'C1') {
              // C1
              this.$router.push({
                path: '/risk/confirm',
              });
            } else {
              this.$router.push({
                path: '/risk/result',
              });
            }
          });
        } else {
          this.$createToast({
            type: 'txt',
            txt: res.msg,
            mask: true,
            time: 2000,
          }).show();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.risk-question {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .risk-question-by {
    background: #fff;
    padding: 0 25px 20px 25px;
    .risk-question-actions {
      display: flex;
      justify-content: space-between;
      padding: 25px 0 10px 0;
      align-items: flex-end;
      .risk-question-actions-a {
        font-size: 12px;
        color: #666;
      }
      .actions-disabled {
        color: #ccc;
      }
      .risk-question-actions-current {
        font-size: 18px;
        color: #222;
        font-weight: bold;
      }
    }
    .risk-question-questions {
      padding-top: 25px;
      .risk-question-questions-title {
        font-size: 15px;
      }
      .risk-question-questions-items {
        padding-top: 20px;
        .risk-question-questions-item {
          padding: 15px;
          border-bottom: 1px solid #f5f5f5;
          font-size: 13px;
        }
        .items-active {
          color: #2e6be6;
          background: #f2f7ff;
        }
      }
    }
  }
  .risk-question-ft {
    .risk-question-tips {
      margin-top: 16px;
      background: #fff;
      padding: 16px;
      .risk-question-tips-title {
        font-size: 15px;
        padding-bottom: 10px;
      }
      .risk-question-tips-content {
        font-size: 13px;
        color: #999;
      }
    }
  }
}
</style>
